import {
  Edit,
  useTranslate,
} from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { DetailForm } from './DetailForm';
import { PERMISSION_RESOURCE } from './utils';

const EditView = () => {
  const translate = useTranslate();

  return (
    <PermissionGuard resource={PERMISSION_RESOURCE} action="update" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('module.announcementPopup.title')}
          links={[
            {
              name: translate('module.announcementPopup.title'),
              href: `/${Resources.announcementPopup}`,
            },
            { name: translate('module.announcementPopup.edit') || 'Edit' },
          ]}
        />
        <Edit
          resource={Resources.announcementPopup}
          redirect="list"
          mutationMode="pessimistic"
          queryOptions={{
            refetchOnWindowFocus: false,
          }}
        >
          <DetailForm />
        </Edit>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default EditView;
